interface FuzzyResult {
  matched: boolean;
  score: number;
  indices: number[];
}

export function fuzzyMatch(query: string, text: string): FuzzyResult {
  if (!query) return { matched: true, score: 0, indices: [] };

  const q = query.toLowerCase();
  const t = text.toLowerCase();
  let qi = 0;
  const indices: number[] = [];

  for (let ti = 0; ti < t.length && qi < q.length; ti++) {
    if (t[ti] === q[qi]) {
      indices.push(ti);
      qi++;
    }
  }

  if (qi < q.length) return { matched: false, score: 0, indices: [] };

  let score = 0;
  let consecutive = 0;
  for (let i = 0; i < indices.length; i++) {
    const idx = indices[i];
    if (i > 0 && idx === indices[i - 1] + 1) {
      consecutive++;
      score += consecutive * 3;
    } else {
      consecutive = 0;
    }
    if (idx === 0 || t[idx - 1] === ' ') score += 5;
    score -= idx * 0.1;
  }

  return { matched: true, score, indices };
}

export interface FuzzyFilterResult<T> {
  item: T;
  indices: number[];
}

export function fuzzyFilter<T>(query: string, items: T[], getKey: (item: T) => string): FuzzyFilterResult<T>[] {
  if (!query.trim()) return items.map(item => ({ item, indices: [] }));

  return items
    .map(item => ({ item, ...fuzzyMatch(query, getKey(item)) }))
    .filter(r => r.matched)
    .sort((a, b) => b.score - a.score)
    .map(({ item, indices }) => ({ item, indices }));
}
